import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import cls from "./button-dropdown.module.scss";
import { MenuDropdownContext, usePortalContainer } from "./MenuContext";
import { ControlledMenu, useMenuState } from "@szhsin/react-menu";
import { getItems } from "./IconDropdown";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ContextMenuContext = React.createContext(null);
export const ContextMenuProvider = (props) => {
    const { children, menuClassName = cls.menu, menuItemClassName = cls.menuItem, menuItemHoverClassName = cls.menuItemHover, menuItemDisabledClassName = cls.menuItemDisabled, menuItemWithSubMenuClassName = cls.menuItemWithSubMenu, ...rest } = props;
    const [{ state }, setOpen] = useMenuState({ initialMounted: false, transition: props.transition, unmountOnClose: true });
    const [anchorPoint, setAnchorPoint] = React.useState({ x: 0, y: 0 });
    const [menu, setMenu] = React.useState(null);
    const container = usePortalContainer(state);
    const showMenu = (menu, e) => {
        e.preventDefault();
        setAnchorPoint({ x: e.clientX, y: e.clientY });
        setMenu(getItems(menu));
        setOpen(true);
    };
    if (state === "closed") {
        setMenu(null);
    }
    return _jsx(ContextMenuContext.Provider, { value: { showMenu }, children: _jsxs(MenuDropdownContext.Provider, { value: { menuClassName, menuItemClassName, menuItemHoverClassName, menuItemDisabledClassName, menuItemWithSubMenuClassName }, children: [children, _jsx(ControlledMenu, { ...rest, menuClassName: menuClassName, anchorPoint: anchorPoint, state: state, onClose: () => setOpen(false), portal: { target: container }, initialMounted: false, unmountOnClose: true, children: menu })] }) });
};
